<template>
  <div>
    <general-table
      ref="generalTable"
      :api-url="APIURL"
      :delete-content="false"
      :block-content="false"
      :edit-content="true"
      :view-content="false"
      :columns="columns"
      :type="type"
    >
      <template #cell(assign)="data">
        <b-btn
          variant="outline-dark"
          class="my-1"
          @click="showSourceData(data.item.office_id)"
        >
          <feather-icon
            icon="UserPlusIcon"
            class="cursor-pointer"
          />
          Assign
        </b-btn>

      </template>
    </general-table>

    <b-modal
      v-model="isModalVisible"
      :title="'Assign User'"
      centered
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <div class="py-1">
        <VSelect
          v-model="user_id"
          :options="optionsAllUser"
          placeholder="User"
        />
        <div class="d-flex justify-content-end">

          <b-btn
            variant="secondary"
            class="mt-2 mr-1"
            @click="isModalVisible = false"
          >
            Close
          </b-btn>

          <div class="mt-2 ">
            <b-button
              v-if="!addUserLoad"
              :disabled="!user_id"
              variant="primary"
              class="ml-1"
              @click="addUser"
            >
              Change
            </b-button>

            <b-button
              v-if="addUserLoad"
              variant="primary"
              disabled
              class="mr-1 d-flex align-items-center"
            >
              <b-spinner
                v-for="item in 3"
                :key="item"
                small
                type="grow"
              />
            </b-button>
          </div>

        </div>

      </div>
    </b-modal>

  </div>
</template>

<script>
import axios from 'axios'
import VSelect from 'vue-select'
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable, VSelect },
  data() {
    return {
      APIURL: '/halal/operation-engs',
      type: 'page',
      columns: [
        { key: 'name', label: 'Engineer' },
        { key: 'email', label: 'Email' },
        { key: 'office_country', label: 'Office' },
        { key: 'assign', label: 'Assign' },
      ],
      isModalVisible: false,
      addUserLoad: false,
      officeId: null,
      user_id: null,
    }
  },

  computed: {
    apiUrl() {
      const filter = this.filter || {}
      let base = '/halal/operation-engs?'

      if (!Object.keys(filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(filter)) {
        if (value !== null && value !== undefined && value !== '') {
          base += `${key}=${value}&`
        }
      }

      return base.slice(0, -1)
    },
    optionsAllUser() {
      const list = this.$store.getters['generalData/assignList/assignList'] || []

      return list.map(user => ({
        value: user.value.id, // ✅ what v-model gets
        label: user.label, // ✅ what user sees
      }))
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/assignList/assignListLoaded']) {
      await this.$store.dispatch('generalData/assignList/fetchAssignList')
    }
  },

  methods: {
    renewGeneralData() {
      this.$refs.generalTable.getAllData()
    },

    showSourceData(data) {
      this.isModalVisible = true
      this.officeId = data
    },
    addUser() {
      this.addUserLoad = true
      //   /halal/operation-engs/office/:officeId
      axios
        .post(`/halal/operation-engs/office/${this.officeId}`,
          { user_id: this.user_id.value })
        .then(() => {
          this.renewGeneralData()
          this.user_id = ''
        })
        .finally(() => {
          this.addUserLoad = false
          this.isModalVisible = false
        })
    },
  },

}
</script>
